var _circle, _circle2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgMaintain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "url(#paint0_linear_1209_23203)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1209_23203",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1209_23203)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 34,
    width: 115,
    height: 171,
    rx: 12,
    fill: "url(#paint1_linear_1209_23203)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 47,
    width: 103,
    height: 158,
    rx: 4,
    fill: "url(#paint2_linear_1209_23203)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1209_23203)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1209_23203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.0706 98.0635C88.0706 101.837 85.0572 104.911 81.351 104.911C77.6447 104.911 74.6313 101.837 74.6313 98.0635C74.6313 94.2898 77.6447 91.216 81.351 91.216C85.0572 91.216 88.0706 94.2898 88.0706 98.0635ZM108.809 108.943L104.329 116.853C103.302 118.67 101.014 119.294 99.2312 118.25C97.2093 117.06 94.7992 117.057 92.7833 118.25C90.7674 119.437 89.5609 121.561 89.5609 123.935C89.5609 126.032 87.8855 127.739 85.8278 127.739H76.8682C74.8105 127.739 73.1351 126.032 73.1351 123.935C73.1351 121.561 71.9315 119.434 69.9127 118.25C67.8968 117.06 65.4867 117.06 63.4678 118.25C61.6848 119.297 59.3972 118.67 58.3668 116.856L53.8871 108.949C52.8597 107.133 53.4719 104.804 55.2519 103.755C57.2738 102.565 58.4773 100.437 58.4773 98.0666C58.4773 95.6958 57.2738 93.5655 55.2549 92.3816C53.4749 91.3286 52.8627 89.0005 53.8871 87.1867L58.3668 79.2771C59.3972 77.4633 61.6848 76.8394 63.4648 77.8802C65.4867 79.0701 67.8968 79.0732 69.9127 77.8802C71.9286 76.6933 73.1351 74.5691 73.1351 72.1953C73.1351 70.0984 74.8105 68.3911 76.8682 68.3911H85.8278C87.8855 68.3911 89.5609 70.0984 89.5609 72.1953C89.5609 74.5691 90.7645 76.6963 92.7833 77.8802C94.7992 79.0701 97.2093 79.0701 99.2282 77.8802C101.011 76.8302 103.296 77.4572 104.329 79.274L108.809 87.1806C109.833 88.9944 109.221 91.3225 107.444 92.3725C105.422 93.5624 104.219 95.6897 104.219 98.0605C104.219 100.431 105.422 102.562 107.441 103.745C109.221 104.798 109.833 107.13 108.809 108.943ZM92.5504 98.0635C92.5504 91.773 87.5271 86.651 81.351 86.651C75.1749 86.651 70.1516 91.773 70.1516 98.0635C70.1516 104.354 75.1749 109.476 81.351 109.476C87.5271 109.476 92.5504 104.354 92.5504 98.0635Z",
    fill: "url(#paint3_linear_1209_23203)"
  }))), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 68,
    y: 40,
    width: 26,
    height: 2,
    rx: 1,
    fill: "#D6A34B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1209_23203",
    x: 46.6387,
    y: 66.1411,
    width: 69.417,
    height: 72.8477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.820833 0 0 0 0 0.652481 0 0 0 0 0.157326 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1209_23203"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1209_23203",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1209_23203",
    x1: 80,
    y1: 160,
    x2: 80,
    y2: 0.0000198979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1209_23203",
    x1: 80.5,
    y1: 34,
    x2: 80.5,
    y2: 205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1209_23203",
    x1: 80.5,
    y1: 47,
    x2: 80.5,
    y2: 205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1209_23203",
    x1: 53.3887,
    y1: 98.065,
    x2: 109.305,
    y2: 98.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1209_23203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 78,
    fill: "white",
    transform: "translate(50 65)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgMaintain);
export default __webpack_public_path__ + "static/media/img_maintain.96ddfba783adc5c500ce68b60a3623e7.svg";
export { ForwardRef as ReactComponent };